"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementPreview = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var NOTICE_CLASS = "m-0 text-caption text-foreground-muted";
var AgreementPreview = exports.AgreementPreview = function AgreementPreview(_ref) {
  var _agreement$name;
  var agreement = _ref.agreement;
  var meta = [agreement.contract_type_name, agreement.business_status, agreement.template_name ? "Template: ".concat(agreement.template_name) : null].filter(Boolean).join(" · ");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.Card, {
    size: "sm",
    className: "my-2",
    "data-sentry-element": "Card",
    "data-sentry-component": "AgreementPreview",
    "data-sentry-source-file": "AgreementPreview.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "AgreementPreview.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start gap-2.5",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DescriptionIcon, {
          className: "text-foreground-muted",
          "data-sentry-element": "DescriptionIcon",
          "data-sentry-source-file": "AgreementPreview.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex min-w-0 flex-1 flex-col gap-0.5",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-body-sm font-semibold text-foreground-primary",
            children: (_agreement$name = agreement.name) !== null && _agreement$name !== void 0 ? _agreement$name : agreement.agreement_id
          }), meta ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-caption text-foreground-muted",
            children: meta
          }) : null]
        })]
      }), !agreement.document_ready ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: NOTICE_CLASS,
        children: "The document has not been assembled yet \u2014 publish the agreement in Icertis to generate it."
      }) : null, agreement.document_ready && agreement.artifact_id ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: (0, _utils.cn)(NOTICE_CLASS, "inline-flex items-center gap-1"),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.TaskIcon, {}), "Saved to your Outputs panel."]
      }) : null, agreement.deeplink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        asChild: true,
        size: "sm",
        className: "self-start",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
          href: agreement.deeplink,
          target: "_blank",
          rel: "noopener noreferrer",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.OpenInNewIcon, {
            "data-icon": "inline-start"
          }), "Open in Icertis"]
        })
      }) : null]
    })
  });
};